document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartItems', () => {
    return {
      itemsRoot: null,
      locked: null,
      init() {
        this.itemsRoot = this.$root;

        window.addEventListener('shapes:modalcart:afteradditem', (e) => {
          console.log(e.detail.response);
          Alpine.morph(
            this.itemsRoot,
            querySelectorInHTMLString(
              '[data-cart-items]',
              e.detail.response.sections['cart-items']
            ).outerHTML
          );
        });

        window.addEventListener('shapes:modalcart:cartqtychange', (e) => {
          console.log('[cart-items] cartqtychange response', e.detail.response);
          Alpine.morph(
            this.itemsRoot,
            querySelectorInHTMLString(
              '[data-cart-items]',
              e.detail.response.sections['cart-items']
            ).outerHTML
          );
          setTimeout(function(){
            document.querySelector(".ageCheck1").dispatchEvent(new Event('change'));
            cartSellingPlanUpdate();
            getCartSlideRecommend();
          });

          this.$nextTick(() => {
            this.itemsRoot.querySelectorAll('input').forEach((inputEl) => {
              inputEl.value = inputEl.getAttribute('value');
            });
          });

          const liveRegionText = parseDOMFromString(
            e.detail.response.sections['cart-live-region']
          ).firstElementChild.textContent;

          const cartStatus = document.getElementById('cart-live-region-text');

          cartStatus.textContent = liveRegionText;

          cartStatus.setAttribute('aria-hidden', false);

          if (e.detail.originalTarget) {
            this.$nextTick(() => {
              if (!this.itemsRoot.contains(e.detail.originalTarget)) {
                let focusRoot;

                if (this.itemsRoot.closest('[role="dialog"]')) {
                  focusRoot =
                    this.itemsRoot.closest('[role="dialog"]').parentNode;
                } else {
                  focusRoot = this.itemsRoot;
                }

                this.$focus.within(focusRoot).first();
              }
            });
          }
        });
      },
      itemQuantityChange(key, value) {
        if (this.locked) return;

        const lineItemEl = this.$el.closest('li[data-cart-item-key]');
        const id = key ? key : lineItemEl.getAttribute('data-cart-item-key'),
          quantity = parseInt(!isNaN(value) ? value : this.$el.value, 10),
          sections = 'cart-items,cart-footer,cart-item-count,cart-live-region';

        const config = fetchConfigDefaults('javascript');

        config.body = JSON.stringify({
          id,
          quantity,
          sections,
          sections_url: window.location.pathname,
        });

        const lastValue = parseInt(this.$el.dataset.lastValue, 10);

        if (quantity !== lastValue) {
          lineItemEl.classList.add('opacity-50', 'cursor-progress');

          const currentCount = Alpine.raw(Alpine.store('cart_count').count);

          this.locked = lineItemEl;

          fetch(theme.routes.cart_change_url, config)
            .then((res) => res.json())
            .then((data) => {
              if (data.status === 422) {
                const errorEl = lineItemEl.querySelector(
                  '[data-cart-quantity-error]'
                );

                errorEl.textContent = data.message;

                errorEl.style.display = '';
                lineItemEl.classList.remove('opacity-50', 'cursor-progress');

                this.$el.value = lastValue;
              } else {
                document.body.dispatchEvent(
                  new CustomEvent('shapes:modalcart:cartqtychange', {
                    bubbles: true,
                    detail: { response: data, originalTarget: lineItemEl },
                  })
                );
              }
            })
            .catch(() => {
              document.getElementById('cart-errors').textContent =
                theme.strings.cartError;
            })
            .finally(() => {
              this.locked = null;
            });
        }
      },
      removeItem(key) {
        this.itemQuantityChange(key, 0);
      },
      _adjustQty(el, operation) {
        let step = 6;
        const inputEl = el
          .closest('li[key]')
          .querySelector('input[type="number"]');
        if(inputEl.getAttribute("data-step") && Number(inputEl.getAttribute("data-step")) > 0) {
          step = Number(inputEl.getAttribute("data-step"));
        }

        const lastValue = parseInt(inputEl.dataset.lastValue, 10);

        let newValue;

        if (operation == 'increment') {
          newValue = lastValue + step;
        }

        if (operation == 'decrement') {
          if (lastValue >= step) {
            newValue = lastValue - step;
          } else {
            newValue = step;
          }
        }

        if (operation == 'remove') {
          newValue = 0;
        }

        inputEl.value = newValue;

        // this.$nextTick(() => {
        inputEl.dispatchEvent(new Event('change', { bubbles: true }));
        // });
      },
      increment() {
        this._adjustQty(this.$el, 'increment');
      },
      decrement() {
        this._adjustQty(this.$el, 'decrement');
      },
      remove() {
        this._adjustQty(this.$el, 'remove');
      },
    };
  });
});
function cartRecommendCTA(e){
  e.preventDefault();
  var that = this;
  this.disabled = true;
  let variantId = this.getAttribute("data-variantid");
  let formData = {
   'items': [{
    'id': variantId,
    'quantity': 6
    }],
    'sections': 'cart-items,cart-footer,cart-item-count',
    'sections_url': window.location.pathname,
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  }).then(response => {
    that.disabled = false;
    document.body.dispatchEvent(
      new CustomEvent('shapes:modalcart:cartqtychange', {
        bubbles: true,
        detail: { response: response, originalTarget: false },
      })
    );
  })
  .catch((error) => {
    that.disabled = false;
    console.error('Error:', error);
  });
}

function getCartSlideRecommend() {
  var cartRecItems = document.querySelector(".cartSlideRecommendItems");
  var cartRecItemsWrapper = document.querySelector(".cartSlideRecommendWrapper");
  if(cartRecItems != null) {
    let url = cartRecItems.getAttribute("data-url");
    fetch(window.Shopify.routes.root + url)
      .then(response => response.json())
      .then(({ products }) => {
        if (products.length > 0) {
          cartRecItemsWrapper.style.display = "block";
          cartRecItems.innerHTML = "";
          let add = cartRecItems.getAttribute("data-add");
          let moneyFormat = cartRecItems.getAttribute("data-moneyformat");
          for(let i=0; i< products.length; i++){
            let product = products[i];
            let recItem = document.createElement("div");
            recItem.className = "cartSlideRecommendItem";
            let recItemImage = document.createElement("img");
            recItemImage.src = product.featured_image;
            recItemImage.className = "cartSlideRecommendItemImage";
            let recItemDetail = document.createElement("div");
            recItemDetail.className = "cartSlideRecommendItemDetail";
            let recItemDetailTitle = document.createElement("div");
            recItemDetailTitle.className = "cartSlideRecommendItemDetailTitle";
            recItemDetailTitle.innerHTML = product.title;
            let recItemDetailPrice = document.createElement("div");
            recItemDetailPrice.className = "cartSlideRecommendItemDetailPrice";
            recItemDetailPrice.innerHTML = formatMoney(product.price, moneyFormat);
            recItemDetail.appendChild(recItemDetailTitle);
            recItemDetail.appendChild(recItemDetailPrice);
            let recItemLink = document.createElement("button");
            recItemLink.setAttribute("data-variantid",product.variants[0].id);
            recItemLink.className = "cartSlideRecommendItemLink";
            recItemLink.innerHTML = add;
            recItemLink.addEventListener("click", cartRecommendCTA);
            recItem.appendChild(recItemImage);
            recItem.appendChild(recItemDetail);
            recItem.appendChild(recItemLink);
            cartRecItems.appendChild(recItem);
          }
        } else {
          cartRecItemsWrapper.style.display = "none";
        }
      }
    );
  }
}

function ageCheckFunction() {
  var cartDrawerCheckout = document.querySelector(".cartCheckoutBtn[name='checkout']");
  if(cartDrawerCheckout != null) {
    if(this.checked) {
      cartDrawerCheckout.disabled = false;
    } else {
      cartDrawerCheckout.disabled = true;
    }
  }
}

function cartSellingPlanUpdate(){
  let allCartSellingPlanSelects = document.querySelectorAll(".cartSlideItemSubscribeSelect");
  if(allCartSellingPlanSelects.length > 0) {
    for(let i=0; i<allCartSellingPlanSelects.length; i++) {
      let allCartSellingPlanSelect = allCartSellingPlanSelects[i];
      allCartSellingPlanSelect.removeEventListener("change", cartSellingPlanHandle);
      allCartSellingPlanSelect.addEventListener("change", cartSellingPlanHandle);
    }
  }
}

function cartSellingPlanHandle(){
  let thisLine = this.getAttribute("data-line");
  let thisQty = this.getAttribute("data-quantity");
  let planSelected = this.value;
  let data = {
    quantity: thisQty,
    line: thisLine,
    selling_plan: planSelected == "one-time" ? null : Number(planSelected)
  }
  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(response => response.json())
  .then(data => console.log(data));
}

function formatMoney(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};